import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AuthCard } from '../../../components/auth/AuthCard';
import { AuthCardTitle } from '../../../components/auth/AuthCardTitle';
import { AuthLayout } from '../../../components/auth/AuthLayout';
import { AuthSubTitle } from '../../../components/auth/AuthSubTitle';
import { getRoute } from '../../../config/routes.config';

export const ForgotSuccessScene = () => {
  const { t } = useTranslation('ForgotSuccessScene');
  return (
    <AuthLayout className="py-96" title={t('passwordResetRequest')}>
      <AuthCard>
        <div className="mb-5">
          <AuthCardTitle>{t('passwordResetRequest')}</AuthCardTitle>
          <AuthSubTitle>{t('passwordResetLink')}</AuthSubTitle>
        </div>
        <Link to={getRoute('LOGIN')} className="text-primary hover:text-primary-500 block text-sm ">
          {t('backToLogin')}
        </Link>
      </AuthCard>
    </AuthLayout>
  );
};
